import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Une clases condicionales y resuelve los conflictos de Tailwind (la ultima gana). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
